import React, { createElement } from 'react';
import { TableCellStyled, TableHeadCellStyled } from './styled';
export function Cell(props) {
    const { row = {}, id = '', cell, colSpan, cellWidth = {}, cellValue, cellPadding, isRightToLeft = false, isHeadCell = false, hasEmptyCells = true, } = props;
    const value = cellValue ?? row[id];
    if (!value && !hasEmptyCells)
        return null;
    return (React.createElement(React.Fragment, null, isHeadCell ? (React.createElement(TableHeadCellStyled, { cellWidth: cellWidth, cellPadding: cellPadding, isRightToLeft: isRightToLeft, ...(colSpan && {
            colSpan,
        }) }, cell
        ? createElement(cell, {
            cellValue,
            cellPadding,
        }, value)
        : value)) : (React.createElement(TableCellStyled, { cellWidth: cellWidth, cellPadding: cellPadding, isRightToLeft: isRightToLeft, ...(colSpan && {
            colSpan,
        }) }, cell
        ? createElement(cell, {
            cellValue,
            cellPadding,
        }, value)
        : value))));
}
Cell.displayName = 'Cell_Component';
